import alt from "../alt";

class PassActions {
  constructor() {
    this.generateActions(
      "updatePasses",
      "fetchAllForPerson",
      "fetchAllForPassBucket",
      "fetchAllForEventBucket",
      "fetchAllForEventBucketIncludingGlobal",
      "fetchOne",
      "fetchPassSubscription",
      "fetchAutocomplete",
      "fetchFailed",
      "delete",
      "deletePasses",
      "deleteFailed",
      "refundPass",
      "editFailed",
      "bulkTransferPasses",
      "bulkCancelPassTransfers",
      "cancelTransfer"
    );
  }

  fetchPassTransferHistory(passId, eventBucketId) {
    return { passId, eventBucketId };
  }

  updatePass(id, pass) {
    return { id, pass };
  }

  updatePassSubscription(id, pass_subscription) {
    return { id, pass_subscription };
  }

  updateAutocomplete(data) {
    return { data };
  }

  edit(id, values) {
    return { id, values };
  }

  transfer(id, recipient) {
    return { id, recipient };
  }

  editPassSubscription(id, values) {
    return { id, values };
  }
}

export default alt.createActions(PassActions);



// WEBPACK FOOTER //
// ./src/app/actions/PassActions.js